// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exactCenter[data-v-906d967e] {
  width: 250px;
  height: 200px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -100px;
  margin-left: -100px;
  z-index: 50000;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/application/document/view.vue","webpack://./view.vue"],"names":[],"mappings":"AACI;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;ACAR","sourcesContent":["\n    .exactCenter {\n        width:250px;\n        height:200px;\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        margin-top: -100px;\n        margin-left: -100px;\n        z-index: 50000;\n    }\n",".exactCenter {\n  width: 250px;\n  height: 200px;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  margin-top: -100px;\n  margin-left: -100px;\n  z-index: 50000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
